import { Component, OnInit} from '@angular/core';
import { FormGroup,  FormBuilder, Validators} from '@angular/forms';
import { GeneralService } from '../../../services/general/general.service';

@Component({
  selector: 'app-pre-register-teacher',
  templateUrl: './pre-register-teacher.component.html',
  styleUrls: ['./pre-register-teacher.component.scss']
})

export class PreRegisterTeacherComponent implements OnInit {

  public loading: any;
  public form1: FormGroup;
  public isMobile: Boolean;
  public lead: any;

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService,
  ) {

    this.loading = false;
    this.isMobile = this.general.isMobile();
    this.lead = null;

    // Step 1
    this.form1 = this.formBuilder.group(
      {
        email: ['', [Validators.required, Validators.email]],
        name: ['', [Validators.required]],
        surname: ['', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        repeatPassword: ['', [Validators.required, Validators.minLength(8)]],
        policy: [false, [Validators.requiredTrue]],
      },
      { validators: this.checkPasswords() }
    );
  }

  ngOnInit(): void {
  }

  async registerTeacher() {

    this.form1.markAllAsTouched();

    try {

      this.loading = true;
      const validated = await this.validateForms();

      if (validated) {
        await this.sendForm1();
        await this.general.sleep(200);
        window.location.reload();
      }

    } catch (error) {
      await this.general.showErrorForm(error);
    } finally {
      this.loading = false;
    }

  }

  /*
   * Validate Form
   */
  async validateForms() {
    // Validate Form1
    if (this.form1.valid) {
      this.form1.markAllAsTouched();
      return true;
    }else return false;
  }

  async sendForm1() {

    let timezone: any = localStorage.getItem('timezone');

    let body: any = {
      name: this.form1.value.name,
      surname: this.form1.value.surname,
      email: this.form1.value.email,
      password: this.form1.value.password,
      password_confirmation: this.form1.value.repeatPassword,
      default_lang: this.general.translate.currentLang,
      timezone,
    };

    if (this.lead) {
      body.lead = this.lead;
    }

    const response = await this.general.httpPost('register/teacher', body);
    localStorage.setItem('access_token', `${response.data.access_token}`);
  }

  /**
   * =================== Validations Form 1===================
   */
   get emailNoValido() {
    return this.form1.get('email')?.invalid && this.form1.get('email')?.touched;
  }

  get invalidName() {
    return this.form1.get('name')?.invalid && this.form1.get('name')?.touched;
  }

  get invalidSurName() {
    return (
      this.form1.get('surname')?.invalid && this.form1.get('surname')?.touched
    );
  }

  get invalidPassword() {
    return (
      this.form1.get('password')?.invalid && this.form1.get('password')?.touched
    );
  }

  get invalidRepeatPassword() {
    return (
      this.form1.get('repeatPassword')?.invalid &&
      this.form1.get('repeatPassword')?.touched
    );
  }

  get invalidPolicy() {
    return (
      this.form1.get('policy')?.invalid && this.form1.get('policy')?.touched
    );
  }

  get validateForm1() {
    return this.form1.valid;
  }

  checkPasswords() {

    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const passwordControl = formGroup.controls['password'];
      const repeatPasswordControl = formGroup.controls['repeatPassword'];

      if (
        passwordControl.value !== repeatPasswordControl.value ||
        !repeatPasswordControl.value
      ) {
        res = { badPasswords: true };
      }
      repeatPasswordControl.setErrors(res);
    };
  }

}